import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import CustomizeUIStore from '../../stores/CustomizeUI/CustomizeUIStore';
import {
    CardTitle,
    ExitMessageOptionField,
    ExitMessageOptionView,
    ExitMessageTextField
} from '../ConsoleExitMessage/ExitMessageFields';
import FuseConsoleCardFooter from '../ConsoleFragments/FuseConsoleCardFooter';
import { Card } from '../Fuse';
import NewFuseWysiwyg from '../Fuse/NewFuseWysiwyg';
import FuseRadioButton from '../FuseControls/FuseRadioButton';
import BaseCustomizeEditModal from './BaseCustomizeEditModal';

class CustomizeExitIsolationModal extends Component {
    static propTypes = {
        customizeUI: CustomizeUIStore.PropType.isRequired,
    };

    render() {
        const { exitMessage } = this.props.customizeUI;
        return <BaseCustomizeEditModal store={exitMessage}>
            <Card title={CardTitle}>
                <ExitMessageOptionField tooltipProps={{ position: 'right' }}>
                    {['DEFAULT', 'CUSTOM'].map((value) => <FuseRadioButton
                        key={value}
                        store={exitMessage.option}
                        value={value}
                        label={ExitMessageOptionView[value]}
                        qa={`exit-isolation-option-${value}`}
                    />)}
                </ExitMessageOptionField>
                {exitMessage.isCustomMessageEditable() ? <Fragment>
                    <ExitMessageTextField>
                        <NewFuseWysiwyg store={exitMessage.content} />
                    </ExitMessageTextField>
                    <FuseConsoleCardFooter text="Text will not be translated to other languages." />
                </Fragment> : null}
            </Card>
        </BaseCustomizeEditModal>;
    }
}
export default inject('customizeUI')(observer(CustomizeExitIsolationModal));
